import request from '@/utils/request';

// 提交物流服务满意度调查问卷
export function submitSatisfactionSurvey(data) {
  return request({
    url: '/app/h5/api/customerSurvey/submit',
    method: 'POST',
    data,
  });
}
// 查询问卷日期详情
export function getSurveyDateDetail(params) {
  return request({
    url: '/app/h5/api/customerSurvey/getSurveyInfo',
    method: 'GET',
    params,
  });
}
